import { type GenericMap, type SettingDefinition } from "@client/types";

import definitions from "./layout/definitions.json";
import structure from "./layout/structure.json";

import { addVersion } from "@client/lib/settings";
import { getStructureDefaultValue, type SettingsStructure } from "./structure";

export const getLayoutSettingsStructure = (): {
  structure: SettingsStructure;
  definitions: GenericMap<SettingDefinition>;
} => ({
  definitions,
  structure
});

export const getDefaultLayoutSettings = (): GenericMap<any> => {
  const defaultSettings = getStructureDefaultValue("layout", structure, definitions);
  return addVersion(defaultSettings);
};
